var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('LinkGroup',{attrs:{"items":_vm.options.items},on:{"itemClick":_vm.itemClickHandle}})}
var staticRenderFns = []

export { render, staticRenderFns }